module.exports = __webpack_public_path__ + "static/interim-services-62a9e10351bde27345bdbf1cadc2d16d.jpg";